var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"member-informations"},[_c('div',{staticClass:"go-back",staticStyle:{"margin-bottom":"0.5rem"}},[_c('el-button',{attrs:{"type":"text","icon":"el-icon-back"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("戻る")])],1),_c('information-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }